import { z } from 'zod'

type Translate = (key: string) => string

export function signInSchema(t: Translate) {
  return z.object({
    email: z.string()
      .min(1, { message: t('customerAuth.emailRequiredError') })
      .email({ message: t('customerAuth.emailInvalidError') }),
    password: z.string()
      .min(1, { message: t('customerAuth.passwordRequiredError') }),
  })
}
